import script from "./LoginAndRegister.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginAndRegister.vue?vue&type=script&lang=ts&setup=true"

import "./LoginAndRegister.vue?vue&type=style&index=0&id=16e40640&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e40640"]])

export default __exports__